// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"f8e3d0a6","377":"154d4652","417":"57c56326","467":"e9ff9ea6","626":"e5e40771","870":"8d0bcedc"}[chunkId] + ".js";
};